const events = {
  all: 'Todo',
  general: {
    search: 'Buscar Evento',
    add: 'Agregar',
    assign: 'Asignar',
    details: 'Detalles del evento',
    fetchError: 'Error al obtener datos',
  },
  selectors: {
    selector2: {
      access: 'Acceso',
      security: 'Seguridad',
      alarms: 'Alarmas',
      troubles: 'Problemas',
      lockdown: 'Bloqueo',
      others: 'Otros',
      cloud: 'Nube',
    },
    selector3: {
      organization: 'Cuenta',
      site: 'Sitio',
      controller: 'Controlador',
      door: 'Puerta',
      accessLevel: 'Nivel de Acceso',
      card: 'Tarjeta',
      user: 'Usuario',
      schedule: 'Horario',
      holiday: 'Vacaciones',
      reader: 'Lector',
    },
  },
  table: {
    date_and_time: 'Fecha y Hora',
    description: 'Descripción',
    object: 'Objeto',
    detail: 'Detalle',
    info: 'Información',
    extraInfo: 'Información extra',
    instigator: 'Instigador',
    event: 'Evento',
    type: 'Tipo',
    id: 'ID',
    displayName: 'Nombre de visualización',
    module: 'Módulo',
    sequenceNumber: 'Número de secuencia',
  },
};

export default events;
